import { signal } from '@angular/core';
export const currentLocale = signal('en');
